import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/styles/theme.css'
import './permission' // 引入路由守卫

Vue.config.productionTip = false
Vue.use(Antd)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')